import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { of } from 'rxjs/internal/observable/of';
import { BehaviorSubject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

type FnObservable<T> = (...args: any) => Observable<T>;

@Injectable({
  providedIn: 'root',
})
export class EntityService {

  constructor() { }

  protected getSavedApiCall<T>(subjects: BehaviorSubject<T>[], apiCall: FnObservable<T>, args?: any):
    Observable<T> {

    const key = this.getKeyByArgs(args);

    if (subjects[key] == null) {
      subjects[key] = new BehaviorSubject<T>(null);
    }

    // @ts-ignore
    return subjects[key].asObservable().pipe(
      switchMap((value: T) => value != null ? of(value) : this.callAndSaveInApiCall(subjects[key], apiCall, args)),
    );
  }

  private callAndSaveInApiCall<T>(subject: BehaviorSubject<T>, apiCall: FnObservable<T>, args: any): Observable<T> {
    return apiCall(...(args ?? [])).pipe(
      tap((value) => subject.next(value)),
    );
  }

  private getKeyByArgs(args: any[]): string {
    const argsFilteredStringAndNumber = this.getStringAndNumberKeyStringify(args);
    let argsHttpParms = this.getHttpParamsStringify(args);
    argsHttpParms = [...argsHttpParms].sort().join('');
    const argsValue = argsFilteredStringAndNumber+argsHttpParms;
    return argsValue === '' ? 'noKey' : argsValue;
  }

  private isNumber(elem: any): boolean {
    return !isNaN(parseFloat(elem)) && !isNaN(elem - 0);
  }

  private getStringAndNumberKeyStringify(args: any[]): string {
    return args == null ? '' : args.filter(arg => typeof arg === 'string' || this.isNumber(arg)).join('-');
  }

  private getHttpParamsStringify(args: any[]): string {
    return args.reduce((base, elem) => elem instanceof HttpParams ? base+elem.toString() : base, '');
  }
}
